const QuizQuestion: React.FC<{question: string}> = ({question}) => {
    return <h1 style={{marginLeft: 10, marginBottom: 30, textAlign:"center" }}>{question}</h1>
}

export default QuizQuestion;